export const cardThemes = {
  300: {
    visa: '#424242',
    mastercard: '#424242',
    elo: '#424242',
    hipercard: '#424242',
  },
  contpet: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  coral: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  easy: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  ethios: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  fanaticos: { 
    visa: '#111111',
    mastercard: '#111111',
    elo: '#111111',
    hipercard: '#111111',
  },
  gavioes: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  ginasticadocerebro: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  jovemflamengo: { 
    visa: '#424242',
    mastercard: '#424242',
    elo: '#424242',
    hipercard: '#424242',
  },
  manchaverde: { 
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  jovemsantos: { 
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  neoglobal: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  padda: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  pontobank: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  rainbow: { 
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  simfacilita: { 
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  soul: {
    visa: '#f7da66',
    mastercard: '#f7da66',
    elo: '#f7da66',
    hipercard: '#f7da66',
  },
  upcash: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
  xpay: {
    visa: '#ffffff',
    mastercard: '#ffffff',
    elo: '#ffffff',
    hipercard: '#ffffff',
  },
};
